import { IDocumentMetadata } from '../modules/digitalization-uploads';

export const KKS: keyof IDocumentMetadata = 'KKS';
export const MASTER_DCC: keyof IDocumentMetadata = 'DocumentClass';
export const CONTENT_DCC: keyof IDocumentMetadata = 'DocumentClassContent';
export const DOCUMENT_ID: keyof IDocumentMetadata = 'documentId';
export const CHECK_BOT_ESTABLISHED_KKS: keyof IDocumentMetadata =
  'checkBotEstablishedKKS';
